import React from "react";
import { FaCheck } from "react-icons/fa";

const PlanItem = ({ value, clickEvent }) => {
  return (
    <li className={value.name}>
      <p>{value.description}</p>
      <strong>{value.name}</strong>
      <div className="price">
        {value.price && <p className="origin">{formatNumber(value.price)}원</p>}
        <div>
          {value.monthlyPrice ? (
            <span>
              <strong>{formatNumber(value.monthlyPrice)}</strong>원/월
            </span>
          ) : (
            <span>
              <strong>{formatNumber(value.monthlyPrice)}</strong>원
            </span>
          )}
        </div>
      </div>
      <ul className="feature">
        {value.features.map((feature, index) => (
          <li>
            <span className="icon">
              <FaCheck />
            </span>
            <span>{feature}</span>
          </li>
        ))}
      </ul>
      <button onClick={() => clickEvent(value.name)}>{value.label}</button>
    </li>
  );
};

export default PlanItem;
